<template>
  <div class="list">
    <h2>한국오션플랫폼</h2>
    <div class="list__inner">
      <table>
        <thead>
          <tr>
            <th scope="col" class="depth">1depth</th>
            <th scope="col" class="depth">2depth</th>
            <th scope="col" class="depth">3depth</th>
            <th scope="col">URL</th>
            <th scope="col">status</th>
            <th scope="col" class="comment">comment</th>
          </tr>
        </thead>
        <tbody>
          <tr-group class="strong" keyname="main" :list="$t('main')" />
          <template v-for="(menu, idx) in $t('header')">
            <tr-group :key="`header-${idx}`" :list="[menu]"></tr-group>

            <template v-for="(sub, sidx) in menu.subs">
              <tr-group :key="`header-${idx}-${sidx}`" :list="[sub]"></tr-group>

              <template v-for="(tab, tidx) in sub.tabs">
                <tr-group
                  :key="`header-${idx}-${sidx}-${tidx}`"
                  :list="[tab]"
                ></tr-group>
              </template>
            </template>
          </template>
          <tr-group keyname="footer" :list="$t('footer.list')" />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import gate from '@/pages/gate';

export default gate;
</script>

<style lang="scss" scoped>
@import '@/assets/styles/gate.scss';
</style>
